import { HttpContextToken } from '@angular/common/http';

export const SUPPRESS_AUTH_REDIRECT = new HttpContextToken<boolean>(() => false);